import { library } from '@fortawesome/fontawesome-svg-core'

/* Free Solid icons */

import { faCarAlt as fasCarAlt } from '@fortawesome/free-solid-svg-icons/faCarAlt'
import { faWalking as fasWalking } from '@fortawesome/free-solid-svg-icons/faWalking'
import { faHashtag as fasHashtag } from '@fortawesome/free-solid-svg-icons/faHashtag'
import { faBicycle as fasBicycle } from '@fortawesome/free-solid-svg-icons/faBicycle'
import { faTimes as fasTimes } from '@fortawesome/free-solid-svg-icons/faTimes'

library.add(fasCarAlt, fasWalking, fasHashtag, fasBicycle, fasTimes)
